// extracted by mini-css-extract-plugin
export default {"container":"Pricing_container__4yADG","generalContainer":"Pricing_generalContainer__qvrDK"};